(function ($) {
  function formOverlay() {
    $(document).on("click", ".subscribe-form", function (e) {
      e.preventDefault();
      $(".subscription-overlay").addClass("overlay-active");
    });
  }

  $(document).ready(function () {
    formOverlay();

    $(document).on("click", ".subscription-overlay .close-form", function () {
      $(".subscription-overlay").removeClass("overlay-active");
    });
  });

  // email validation code starts
  $(function () {
    var regExp = /^([\w\.\+]{1,})([^\W])(@)([\w]{1,})(\.[\w]{1,})+$/;

    $(".inner-overlay .form-container form #email").on("keyup", function () {
      regExp.test($(this).val())
        ? $(".inner-overlay .form-container form .message").removeClass("show")
        : $(".inner-overlay .form-container form .message").addClass("show");
      if ($(".inner-overlay .form-container form .message").hasClass("show")) {
        $(this)
          .parents("form")
          .find("#email")
          .css({ border: "2px solid #98002e" });
      } else {
        $("body .inner-overlay .form-container form #email").css({
          border: "1px solid #B9B9B9",
        });
      }

      if ($(this).val() == "") {
        $(this).parent().find('label[for="email"]').removeClass("email-label");
        $(".inner-overlay .form-container form #email").css({
          border: "1px solid #cb0000",
        });
      } else {
        $(this).parent().find('label[for="email"]').addClass("email-label");
        $(this)
          .parents("form")
          .find("#email")
          .css({ border: "2px solid #98002e" });
      }
    });
    $(".inner-overlay .form-container form #email")
      .on("blur", function () {
        if (
          $(".inner-overlay .form-container form .message").hasClass("show")
        ) {
          $(".inner-overlay .form-container form #email").css({
            border: "1px solid #cb0000",
          });
        } else {
          $(this).css({ border: "1px solid #707070" });
          $('.inner-overlay .form-container form label[for="email"]').addClass(
            "email-label-color"
          );
        }
      })
      .on("focus", function () {
        $(this).css({ border: "2px solid #98002e" });
        $('.inner-overlay .form-container form label[for="email"]').addClass(
          "email-label"
        );
        $('.inner-overlay .form-container form label[for="email"]').removeClass(
          "email-label-color"
        );
      });
  });
})(jQuery);
